/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';

import { getValue } from '@/helpers/GetValueHelper';

import { Card1Content } from './Card1Content';
import { Card2Content } from './Card2Content';
import { Card3Content } from './Card3Content';
import { ICardAreasProps } from './interface';
import { CardImage } from './CardImage';
import { Card4Content } from './Card4Content';
import { Card5Content } from './Card5Content';
import { Card6Content } from './Card6Content';

export const Card = ({ data, image, onClick, type }: ICardAreasProps) => {
  const {
    id,
    text_1,
    text_2,
    text_3,
    text_4,
    text_5,
    text_6,
    cta,
    icon,
    header_1,
    header_2,
  } = data;

  const getCardType = () => {
    // [1,2,3,4,5,6] lines filled
    if (text_1 && text_2 && text_3 && text_4 && text_5 && text_6) {
      return 1;
    }

    // [1,4,5,6] lines filled
    if (text_1 && !text_3 && text_4 && text_5) {
      return 2;
    }

    // [1,5,6] lines filled
    if (text_1 && !text_2 && !text_3 && !text_4 && text_5 && text_6) {
      return 4;
    }

    // [1,4,6] lines filled
    if (text_1 && !text_2 && !text_3 && text_4 && !text_5 && text_6) {
      return 5;
    }

    // [1,2,5] lines filled
    if (text_1 && text_2 && !text_3 && !text_4 && text_5 && !text_6) {
      return 6;
    }

    // [1,3,5] lines filled
    return 3;
  };

  const getCardContent = () => {
    const cardTypeKey = getCardType();
    const cardTypes = {
      1: () => <Card1Content data={data} />,
      2: () => <Card2Content data={data} />,
      3: () => <Card3Content data={data} />,
      4: () => <Card4Content data={data} />,
      5: () => <Card5Content data={data} />,
      6: () => <Card6Content data={data} />,
    };

    return cardTypes[cardTypeKey]();
  };

  const getClassIcon = () => {
    if (getCardType() === 3) {
      return 'vitrine-template2__card--icon-educational';
    }

    return 'vitrine-template2__card--icon';
  };

  const hasShadow = () => {
    return !getValue(data, 'image.imageExternalUrl', '');
  };

  const linkFormatted = useMemo(() => {
    return decodeURI(getValue(cta, '[0].link', '') as string);
  }, [cta]);

  return (
    <a
      href={linkFormatted}
      className="vitrine-template2__card"
      title={text_1}
      onClick={e => onClick(e, id)}
      data-id={id}
    >
      <CardImage value={image as string} withShadow={hasShadow()} type={type}>
        {header_1 ? (
          <div className="vitrine-template2--layout-2__card--white-border-container">
            <span>{header_1}</span>
            <img key={`icon-${id}`} src={`${icon}`} alt={text_1} />
            <span>{header_2}</span>
          </div>
        ) : null}

        {icon && !header_1 ? (
          <img
            key={`icon-${id}`}
            src={`${icon}`}
            alt={text_1}
            className={getClassIcon()}
          />
        ) : null}
        <div className="vitrine-template2__card--link">{getCardContent()}</div>
      </CardImage>
    </a>
  );
};
